<h1 mat-dialog-title class="text-align-center text-danger" *ngIf="data.action === 'delete'">Are you sure to delete?</h1>
<div mat-dialog-content *ngIf="data.action === 'delete'" class="row  d-flex flex-dir-column justify-content-center">
  <p class="fs-6">{{data.questionObj.question}}</p>
</div>
<div mat-dialog-content class="d-flex" [ngClass]="data.questionObj.appliedTo.length > 0 ? 'min-vh-45': ''" *ngIf="data.action !== 'delete'">
  <div class="pe-2 mt-1">{{data.index + 1}}.</div>
  <div class="flex-grow-1">
    <div class="d-flex">
      <div class="flex-grow-1">
        <div class="w-95 rounded-top" #newQuestionEditor [froalaEditor]="editorObj" [(froalaModel)]="data.questionObj.questionHtml"></div>
        <div class="question-menu qs-froala-toolbar w-95 rounded-bottom"></div>
      </div>
      <div>
        <mat-form-field>
          <mat-label>Type*</mat-label>
          <mat-select [(ngModel)]="selectedType" (selectionChange) ="changeQsType($event)">
            <mat-option *ngFor="let type of qTypes"
                        [value]="type.name">{{type.name}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="d-flex flex-dir-column mt-2">
      <mat-form-field class="w-75 mt-2" *ngIf="data.questionObj.type === 'Short Answer' || data.questionObj.type === 'Long Answer'">
        <mat-label>Enter Placeholder Text</mat-label>
        <input matInput [(ngModel)]="data.questionObj.placeholder">
      </mat-form-field>

      <div class="d-flex flex-dir-column" *ngIf="data.questionObj.type === 'Multiple Choice'">
        <div class="d-flex" *ngFor="let option of data.questionObj.multipleOptions; let rdx= index">
          <mat-radio-group aria-label="Select an option" class="align-self-center pe-2">
            <mat-radio-button value="" [disabled]="true"></mat-radio-button>
          </mat-radio-group>

          <mat-form-field class="w-50" [floatLabel]="'never'">
            <mat-label>Option {{rdx + 1}}</mat-label>
            <input matInput placeholder="Enter Option" [(ngModel)]="option.value">
          </mat-form-field>

          <mat-icon class="align-self-center fs-5 mt-2" color="danger" (click)="spliceRadioBtn(rdx)">delete_outline</mat-icon>
        </div>
        <div class="d-flex">
          <mat-icon class="align-self-start c-pointer" color="green" (click)="addRadioBtn(1)">add_circle</mat-icon>
        </div>
      </div>

      <div class="d-flex flex-dir-column" *ngIf="data.questionObj.type === 'Check Boxes'">
        <div class="d-flex" *ngFor="let checkbox of data.questionObj.checkboxes; let cdx= index">
          <mat-checkbox [disabled]="true" class="align-self-center pe-3"></mat-checkbox>

          <mat-form-field class="w-50" [floatLabel]="'never'">
            <mat-label>Option {{cdx + 1}}</mat-label>
            <input matInput placeholder="Enter Option" [(ngModel)]="checkbox.value">
          </mat-form-field>

          <mat-icon class="align-self-center mt-2 fs-5" color="danger" (click)="spliceCheckbox(cdx)">delete_outline</mat-icon>
        </div>
        <div class="d-flex">
          <mat-icon class="align-self-start icon-color" color="green" (click)="addCheckbox(1)">add_circle</mat-icon>
        </div>
      </div>

      <mat-form-field appearance="fill" class="w-25" *ngIf="data.questionObj.type === 'Date'">
        <mat-label>Month, Day, Year</mat-label>
        <input matInput [matDatepicker]="dp1" disabled>
        <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
        <mat-datepicker #dp1></mat-datepicker>
      </mat-form-field>

      <lib-star-rating *ngIf="data.questionObj.type === 'Rating'" [ratingGiven]="0" [disable]="true"></lib-star-rating>
    </div>

    <div class="d-flex justify-content-between flex-dir-column">
      <div class="d-flex my-4">
        <!-- "Roll on" (rollOn) is hidden: the flag is persisted but no code acts
             on it, so the toggle misled users (CU-868kumxpc). Re-show it if/when
             answer carry-forward across year buckets is implemented. -->
        <mat-slide-toggle class="align-self-center" [(ngModel)]="data.questionObj.mandatory">Mandatory</mat-slide-toggle>
      </div>
    </div>
  </div>
</div>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>CANCEL</button>
  <button mat-button cdkFocusInitial class="bg-light-blue text-white" *ngIf="data.action === 'add'" (click)="onAdd()">
    <mat-icon *ngIf="loader">
      <mat-spinner [diameter]="20" color="primary"></mat-spinner>
    </mat-icon>
    CREATE
  </button>
  <button mat-button cdkFocusInitial class="bg-secondary text-white" *ngIf="data.action === 'edit'" (click)="onUpdate()">
    <mat-icon *ngIf="loader">
      <mat-spinner [diameter]="20" color="primary"></mat-spinner>
    </mat-icon>
    UPDATE
  </button>
  <button mat-button cdkFocusInitial class="bg-danger text-white" *ngIf="data.action === 'delete'" (click)="onDelete()">
    <mat-icon *ngIf="loader">
      <mat-spinner [diameter]="20" color="primary"></mat-spinner>
    </mat-icon>
    DELETE
  </button>
</mat-dialog-actions>
